import React from "react";
import { FiCopy, FiExternalLink } from "react-icons/fi";

/**
 * Component để hiển thị thông tin chung của yêu cầu phân tích
 */
export const GeneralInfoSection = ({ analysis, formatDate }) => {
  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    alert(`Đã copy ${label}`);
  };

  return (
    <section className="bg-white border border-gray-100 rounded-2xl p-4 sm:p-6 shadow-sm space-y-4">
      <h4 className="text-base font-semibold text-gray-900 flex items-center gap-2">
        <span className="text-lg">📌</span>
        Thông Tin Chung
      </h4>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Request ID */}
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100">
          <p className="text-xs uppercase text-gray-500 font-semibold mb-1">
            Request ID
          </p>
          <div className="flex items-center gap-2">
            <p className="font-mono text-sm text-gray-900 break-all flex-1">
              {analysis.request_id || "N/A"}
            </p>
            <button
              onClick={() => copyToClipboard(analysis.request_id, "Request ID")}
              className="p-1 hover:bg-gray-200 rounded transition-colors text-gray-500 hover:text-gray-700"
              title="Copy Request ID"
            >
              <FiCopy size={16} />
            </button>
          </div>
        </div>

        {/* Task ID */}
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100">
          <p className="text-xs uppercase text-gray-500 font-semibold mb-1">
            Task ID
          </p>
          <div className="flex items-center gap-2">
            <p className="font-mono text-sm text-gray-900 break-all flex-1">
              {analysis.taskId || analysis.result?.task_id || "N/A"}
            </p>
            <button
              onClick={() =>
                copyToClipboard(
                  analysis.taskId || analysis.result?.task_id,
                  "Task ID"
                )
              }
              className="p-1 hover:bg-gray-200 rounded transition-colors text-gray-500 hover:text-gray-700"
              title="Copy Task ID"
            >
              <FiCopy size={16} />
            </button>
          </div>
        </div>

        {/* Người dùng */}
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100">
          <p className="text-xs uppercase text-gray-500 font-semibold mb-1">
            Người Dùng
          </p>
          <p className="text-sm text-gray-900 font-medium">
            {analysis.userId || "Không rõ"}
          </p>
        </div>

        {/* Trạng thái */}
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100">
          <p className="text-xs uppercase text-gray-500 font-semibold mb-1">
            Trạng Thái
          </p>
          <p className="text-sm text-gray-900 font-medium capitalize">
            {analysis.status || "N/A"}
          </p>
        </div>

        {/* Thời gian tạo */}
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100">
          <p className="text-xs uppercase text-gray-500 font-semibold mb-1">
            Tạo Lúc
          </p>
          <p className="text-sm text-gray-900">
            {formatDate(analysis.created_at) || "N/A"}
          </p>
        </div>

        {/* Thời gian hoàn thành */}
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100">
          <p className="text-xs uppercase text-gray-500 font-semibold mb-1">
            Cập Nhật Lần Cuối
          </p>
          <p className="text-sm text-gray-900">
            {formatDate(analysis.updated_at || analysis.completed_at) || "N/A"}
          </p>
        </div>
      </div>

      {/* Manus Task Link */}
      {analysis.manus_response?.task?.task_id && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-center gap-2">
          <span className="text-lg">🔗</span>
          <div className="flex-1">
            <p className="text-xs uppercase text-blue-600 font-semibold mb-1">
              Manus Task
            </p>
            <p className="text-sm text-blue-700">
              ID: {analysis.manus_response.task.task_id}
            </p>
          </div>
          <a
            href={`https://manus.im/app/tasks/${analysis.manus_response.task.task_id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 hover:bg-blue-100 rounded transition-colors text-blue-600"
            title="Open in Manus"
          >
            <FiExternalLink size={18} />
          </a>
        </div>
      )}
    </section>
  );
};

export default GeneralInfoSection;
